<template>
  <base-button type="text" size="sm" @click="assign(todoItem)" class="tw-whitespace-nowrap" :disabled="isLocationFiltered || disabled == true">
    {{ getUser(todoItem.assignedToUserId) }}
  </base-button>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "AssignedUserButton",
  props: { todoItem: Object, businessUsers: Array, disabled: Boolean },
  computed: {
    ...mapGetters("role", { isLocationFiltered: "isLocationFiltered" }),
  },
  methods: {
    assign(todoItemId) {
      this.$emit("assign", todoItemId);
    },
    getUser(userId) {
      if (!userId) {
        if (this.isLocationFiltered == false) return "Assign";
        else return "";
      }

      if (this.businessUsers.some((u) => u.userId === userId)) {
        return this.businessUsers.find((u) => u.userId === userId).fullName;
      } else {
        return "";
      }
    },
  },
};
</script>
